import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { QuotationValidateCoveragesComponent } from '../quotation-dialog/quotation-validate-coverages/quotation-validate-coverages.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatOption } from '@angular/material/core';
import { firstValueFrom } from 'rxjs';
import { MessageDialogComponent } from '../quotation-dialog/message-dialog/message-dialog.component';
import { AnnualInsurance } from '../../shared/models/quotation-model/catalogs/annual-insurance.model';
import { Brand } from '../../shared/models/quotation-model/catalogs/brand.model';
import { Coverage } from '../../shared/models/quotation-model/catalogs/coverage.model';
import { DeadLine } from '../../shared/models/quotation-model/catalogs/dead-line.model';
import { InsurancePayment } from '../../shared/models/quotation-model/catalogs/insurance-payment.model';
import { Insurance } from '../../shared/models/quotation-model/catalogs/insurance.model';
import { PlanType } from '../../shared/models/quotation-model/catalogs/plan-type.model';
import { Plan } from '../../shared/models/quotation-model/catalogs/plan.model';
import { Program } from '../../shared/models/quotation-model/catalogs/program.model';
import { Model } from '../../shared/models/quotation-model/catalogs/quotation-model.model';
import { VehicleUse } from '../../shared/models/quotation-model/catalogs/vehicle-use.model.model';
import { QuotationComparative } from '../../shared/models/quotation-model/main/quotation-comparative.model';
import { QuotationCompareCoverages } from '../../shared/models/quotation-model/main/quotation-compare-coverages.model';
import { QuotationCompareDeadLines } from '../../shared/models/quotation-model/main/quotation-compare-deadlines.model';
import { QuotationEditFinalValues } from '../../shared/models/quotation-model/main/quotation-edit-final-values.model';
import { QuotationFinancialValues } from '../../shared/models/quotation-model/main/quotation-financial-values.model';
import { QuoatationPlan } from '../../shared/models/quotation-model/main/quotation-plan.model';
import { QuotationRatification } from '../../shared/models/quotation-model/main/quotation-ratification.model';
import { SendTicketObj } from '../../shared/models/quotation-model/main/send-ticket.model.model';
import { UpdateTicketObj } from '../../shared/models/quotation-model/main/update-ticket.model';
import { AnnualInsuranceService } from '../../shared/services/quotation/catalogs/annual-Insurance.service';
import { CoverageService } from '../../shared/services/quotation/catalogs/coverage.service';
import { DeadLineService } from '../../shared/services/quotation/catalogs/dead-line.service';
import { InsurancePaymentService } from '../../shared/services/quotation/catalogs/insurance-payment.service';
import { PlanService } from '../../shared/services/quotation/catalogs/plan.service';
import { VehicleUseService } from '../../shared/services/quotation/catalogs/vehicle-use.service';
import { EventEmiterService } from '../../shared/services/quotation/event-emiter.service';
import { QuotationService } from '../../shared/services/quotation/quotation.service';
import { ProgramService } from '../../shared/services/quotation/program.service';
import { InsuranceService } from '../../shared/services/quotation/catalogs/insurance.service';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatCheckbox } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { InputGeneralRadioButtonComponent } from '../../shared/inputs/input-general-radio-button/input-general-radio-button.component';
import { GeneralService } from '../../shared/services/general.service';

@Component({
  selector: 'app-financing-section',
  templateUrl: './financing-section.component.html',
  styleUrls: ['./financing-section.component.scss'],

  imports: [
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatError,
    MatCheckbox,
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
  ],
})
export class FinancingSectionComponent implements OnInit {
  @Input() quotationId: any;
  @Input() ticketId!: number;
  @Input() selectedBrand = {} as Brand;
  @Input() modelSelected = {} as Model;
  @Input() planTypes!: PlanType[];

  @Output() comparativeComponentReturn = new EventEmitter<any>();
  @Output() financingReturn = new EventEmitter<{
    //se usa en summary
    // selectedPlanType: PlanType;
    // selectedInsurance: Insurance;
    selectedProgram: Program;
    selectedCoverages: Coverage[];
    selectedDeadLines: DeadLine[];
    deadLines: DeadLine[];
    coverages: Coverage[];
  }>();
  hasQuotation: boolean = false;

  activeFinancing: boolean = true;
  showNext: boolean = false;

  isAuto!: boolean;

  financingFormGroup!: FormGroup;
  financialValuesGroup!: FormGroup;

  vehicleUses!: VehicleUse[];
  selectedVehicleUses: VehicleUse[] = [];
  vehicleUse = {} as VehicleUse;

  brands!: Brand[];
  brandDummy = {} as Brand;

  deadLines: DeadLine[] = [];
  selectedDeadLines: DeadLine[] = [];
  deadLine = {} as DeadLine;

  coverages!: Coverage[];
  selectedCoverages: Coverage[] = [];
  coverage = {} as Coverage;

  insurancePayments!: InsurancePayment[];
  insurancePaymentSelected: InsurancePayment[] = [];
  insurancePayment = {} as InsurancePayment;

  deadLinesCompare!: QuotationCompareDeadLines[];
  coveragesCompare!: QuotationCompareCoverages[];
  selectedDeadline!: DeadLine;

  annualInsurances!: AnnualInsurance[];
  annualInsuranceSelected: AnnualInsurance[] = [];
  annualInsurance = {} as AnnualInsurance;

  selectedPlanType = {} as PlanType;

  programs!: Program[];
  selectedProgram = {} as Program;

  quotationPlan: QuoatationPlan = {} as QuoatationPlan;

  plans!: Plan[];
  plan = {} as Plan;
  selectedPlan = {} as Plan;

  insurances!: Insurance[];
  selectedInsurance = {} as Insurance;

  quotationComparatives: QuotationComparative[] = [];
  selectedQuotationComparative!: QuotationComparative;
  quotationFinancialValues!: QuotationFinancialValues;
  selectedQuotationFinancialValue: QuotationEditFinalValues = {} as QuotationEditFinalValues;
  quotationRatification: QuotationRatification = {} as QuotationRatification;
  deadLineQuotationComparative!: QuotationCompareDeadLines[];
  coveragesQuotationComparative!: QuotationCompareCoverages[];

  sendTicketObj: SendTicketObj = {} as SendTicketObj;
  updateItemTicketObj: UpdateTicketObj = {} as UpdateTicketObj;

  comparativeData: any;
  checkDeadlines!: number;
  checkCoverages!: number;
  // Responsivbo
  @Input() financingSectionColumm = 2;

  constructor(
    public dialog: MatDialog,
    private vehicleUseService: VehicleUseService,
    private insurancePaymentService: InsurancePaymentService,
    private quotationService: QuotationService,
    private formBuilder: FormBuilder,
    private annualInsuranceService: AnnualInsuranceService,
    private planService: PlanService,
    private ProgramService: ProgramService,
    private InsuranceService: InsuranceService,
    private coverageService: CoverageService,
    private deadLineService: DeadLineService,
    private loader: EventEmiterService,
    private ngZone: NgZone,
    private translate: TranslateService,
    private generalService: GeneralService,
  ) {}

  ngOnInit(): void {
    this.quotationFinancialValues = {} as QuotationFinancialValues;
    this.checkDeadlines = 0;
    this.checkCoverages = 0;

    this.financingFormGroup = this.formBuilder.group({
      dealer: ['', Validators.required],
      agreement: ['', Validators.required],
      arrangement: ['', Validators.required],
      insuranceCarrier: ['', Validators.required],
    });

    if (this.quotationId > 0) {
      this.hasQuotation = true;
    }
  }

  validateOption(options: any, control: any) {
    const selectedOption = control.value;
    if (!selectedOption || !options.some((obj: any) => obj.id === selectedOption)) {
      return { invalidOption: true };
    }
    return null;
  }

  //se va a todos los componentes
  async loadQuotation() {
    var response = await firstValueFrom(
      this.quotationService.getQuotationFinancialValues(this.quotationId),
    );
    //se usa en summary, financing y asset
    this.selectedBrand = { id: response.brandId, description: response.brandDescription } as Brand;
    //se usa en asset y financing
    this.modelSelected = { id: response.modelId, description: response.modelDescription } as Model;
    //se uusa en summary y financing,
    if (this.planTypes.some((obj) => obj.id === response.quotationPlanType))
      this.selectedPlanType = {
        id: response.quotationPlanType,
        description: this.planTypes.find((obj) => obj.id === response.quotationPlanType)
          ?.description,
      } as PlanType;
    //se usa en summary y financing
    this.selectedPlan = { id: response.planId, description: response.planDescription } as Plan;
    //se usa en financing y summary
    this.selectedProgram = {
      id: response.programId,
      description: response.programDescription,
    } as Program;
    //se usa en summary y financing
    this.selectedInsurance = {
      id: response.insuranceId,
      description: response.insuranceDescription,
    } as Insurance;
    //financingy others?
    this.selectedDeadline = {
      id: response.deadlineId,
      description: response.deadlineDescription.toString(),
    };

    //financing
    await this.loadInsurances();
    //se usa en financing
    await this.loadPlans(response.brandId, response.modelId);
    //financing
    await this.loadPrograms(response.modelId, response.planId);
    //Se actualizan las validaciones con los nuevo arreglos antes de cargar los datos
    this.financingFormGroup
      .get('dealer')!
      .setValidators([Validators.required, this.validateOption.bind(this, this.planTypes)]);
    this.financingFormGroup
      .get('agreement')!
      .setValidators([Validators.required, this.validateOption.bind(this, this.plans)]);
    this.financingFormGroup
      .get('arrangement')!
      .setValidators([Validators.required, this.validateOption.bind(this, this.programs)]);
    this.financingFormGroup
      .get('insuranceCarrier')!
      .setValidators([Validators.required, this.validateOption.bind(this, this.insurances)]);
    this.financingFormGroup.updateValueAndValidity();
    //Se cargan los nuevo datos en el formulario
    this.loadFinancingData(
      response.quotationPlanType,
      response.planId,
      response.programId,
      response.insuranceId,
    );
    //todos? o financing
    await this.loadDeadLinesUpdateQuotation(
      response.planId,
      response.insuranceId,
      response.programId,
      response.deadlines,
    );
    await this.loadCoveragesUpdateQuoatation(
      response.brandId,
      response.insuranceId,
      response.coverages,
    );

    this.ngZone.run(() => {
      this.showNext = true;
    });

    //financing
    await this.loadInsurancePayments();
    //financing
    await this.updateQuotationComparative(
      this.deadLineQuotationComparative,
      this.coveragesQuotationComparative,
    );
  }

  onSubmitFinancing(auto: boolean = false) {
    this.isAuto = auto;
    if (this.checkCoverages <= 0 || this.checkDeadlines <= 0 || this.financingFormGroup.invalid) {
      if (this.checkCoverages <= 0) {
        this.checkCoverages = 0;
      }
      if (this.checkDeadlines <= 0) {
        this.checkDeadlines = 0;
      }
      if (auto) {
        this.loader.isLoadingPage(false);
        this.openDialogChangesWarning();
        this.financingFormGroup.markAllAsTouched();
      } else {
        this.openDialogValidateCoverages();
      }
      return;
    }
    this.generalService.emitGeneralEvent({});
    this.loadFinancingDatas();
    this.sendFinancingToParent();
  }

  openDialogValidateCoverages() {
    const dialogRef = this.dialog.open(QuotationValidateCoveragesComponent, {
      width: '350px',
      panelClass: 'dialog-container-custom',
    });
  }

  openDialogChangesWarning() {
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: '350px',
      height: '200px',
      data: this.translate.instant('quotation.fieldNames.changesDetected'),
      panelClass: 'dialog-container-custom',
    });
  }

  loadFinancingData(
    planTypeIdObj: any,
    planIdObj: any,
    arrangementObj: any,
    insuranceCarrierObj: any,
  ) {
    this.financingFormGroup.patchValue({
      dealer: planTypeIdObj,
      agreement: planIdObj,
      arrangement: arrangementObj,
      insuranceCarrier: insuranceCarrierObj,
    });
  }

  async loadFinancingDatas(refresh = false) {
    this.loader.isLoadingPage(true);
    this.quotationComparatives = await firstValueFrom(
      this.quotationService.compareQuotation(
        this.quotationId,
        this.loadDeadLineCompare(),
        this.loadCoveragesCompare(),
      ),
    );
    this.loader.isLoadingPage(false);
    if (!this.hasQuotation || refresh) {
      this.selectedDeadline = { id: 0, description: 'nada' };
    }
    this.sendToComparative();
  }

  async onChangeDealer(event: any) {
    this.showNext = false;
    const option = event.source.selected;
    this.selectedPlanType = { id: option.value, description: option.viewValue } as PlanType;
    this.financingFormGroup.get('agreement')!.setValue(null);
    this.financingFormGroup.get('arrangement')!.setValue(null);
    this.deleteSelected();
    await this.loadPlans(this.selectedBrand.id, this.modelSelected.id);
    this.financingFormGroup
      .get('agreement')!
      .setValidators([Validators.required, this.validateOption.bind(this, this.plans)]);
    //this.financingFormGroup.updateValueAndValidity();
  }

  async onChangeInsuranceCarrier(event: any) {
    const option = event.source.selected;
    this.selectedInsurance = { id: option.value, description: option.viewValue } as Insurance;
    this.coverages = [];

    this.coverages = await firstValueFrom(
      this.coverageService.getCoverages(this.selectedBrand.id, this.selectedInsurance.id),
    );

    this.deadLines = await firstValueFrom(
      this.deadLineService.getDeadLines(
        this.selectedPlan.id,
        this.selectedInsurance.id,
        this.selectedProgram.id,
      ),
    );

    this.quotationRatification.quotationId = this.quotationId;
    this.quotationRatification.insuranceId = this.selectedInsurance.id;
    this.quotationRatification.planId = this.selectedPlan.id;
    this.quotationRatification.programId = this.selectedProgram.id;

    this.quotationService
      .changeRatificationQuotation(this.quotationRatification)
      .subscribe((response) => {});

    this.ngZone.run(() => {
      this.showNext = true;
    });
    this.resetSelected();
  }

  async onChangeArrangement(event: any) {
    this.showNext = false;
    const option = event.source.selected;
    this.selectedProgram = { id: option.value, description: option.viewValue } as Program;
    this.selectedInsurance = {} as Insurance;
    this.deleteSelected();
    await this.loadInsurances();
    this.financingFormGroup
      .get('insuranceCarrier')!
      .setValidators([Validators.required, this.validateOption.bind(this, this.insurances)]);
    //this.financingFormGroup.updateValueAndValidity();
  }

  async onChangePlan(event: any) {
    this.showNext = false;
    const option = event.source.selected;
    this.selectedPlan = { id: option.value, description: option.viewValue } as Plan;
    this.quotationPlan.planId = this.selectedPlan.id;
    this.quotationPlan.quotationId = this.quotationId;
    this.quotationService.changePlanTypeQuotation(this.quotationPlan).subscribe((response) => {});
    this.financingFormGroup.get('arrangement')!.setValue(null);
    this.deleteSelected();
    await this.loadPrograms(this.modelSelected.id, this.selectedPlan.id);
    this.financingFormGroup
      .get('arrangement')!
      .setValidators([Validators.required, this.validateOption.bind(this, this.programs)]);
    //this.financingFormGroup.updateValueAndValidity();
  }

  onChangeDeadLine(event: any, deadLineId: number, deadLineValue: string) {
    const isSelected: boolean = event.checked;
    const checkDeadlines = this.checkDeadlines;
    if (isSelected) {
      const deadLine = { id: deadLineId, description: deadLineValue } as DeadLine;
      this.selectedDeadLines.push(deadLine);
      this.checkDeadlines++;
      if (this.checkDeadlines - checkDeadlines > 1) {
        this.checkDeadlines = checkDeadlines + 1;
      }
    } else {
      const index = this.selectedDeadLines.findIndex((x) => x.id === deadLineId);
      if (index > -1) {
        this.selectedDeadLines.splice(index, 1);
      }
      this.checkDeadlines--;
      if (this.checkDeadlines - checkDeadlines < -1) {
        this.checkDeadlines = checkDeadlines - 1;
      }
    }
    this.editFinancialValuesDataWithoutFields();
  }

  onChangeCoverage(event: any, coverageId: number, coverageDescription: string) {
    const isSelected: boolean = event.checked;
    const checkCoverages = this.checkCoverages;

    if (isSelected) {
      const coverage = { id: coverageId, description: coverageDescription } as Coverage;
      this.selectedCoverages.push(coverage);
      this.checkCoverages++;
      if (this.checkCoverages - checkCoverages > 1) {
        this.checkCoverages = checkCoverages + 1;
      }
    } else {
      const index = this.selectedCoverages.findIndex((x) => x.id === coverageId);
      if (index > -1) {
        this.selectedCoverages.splice(index, 1);
      }
      this.checkCoverages--;
      if (this.checkCoverages - checkCoverages < -1) {
        this.checkCoverages = checkCoverages - 1;
      }
    }
    this.editFinancialValuesDataWithoutFields();
  }

  editFinancialValuesDataWithoutFields() {
    if (!this.hasQuotation) {
      this.selectedDeadline = { id: 0, description: 'nada' };
    }
    if (this.loadDeadLineCompare().length != 0 && this.loadCoveragesCompare().length != 0) {
      this.quotationService
        .compareQuotation(this.quotationId, this.loadDeadLineCompare(), this.loadCoveragesCompare())
        .subscribe((response) => {
          this.quotationComparatives = response;
          this.sendToComparative();
        });
    } else {
      this.quotationComparatives = [];
      this.sendToComparative();
    }
  }

  async loadInsurances() {
    this.insurances = await firstValueFrom(this.InsuranceService.getInsurance());
  }

  async loadPrograms(modelId: number, planId: number) {
    this.programs = await firstValueFrom(this.ProgramService.getPrograms(modelId, planId));
  }

  async loadCoveragesUpdateQuoatation(brandId: any, insuranceId: any, coveragesUpdate: string) {
    this.coveragesQuotationComparative = [];
    this.coverages = await firstValueFrom(this.coverageService.getCoverages(brandId, insuranceId));
    coveragesUpdate.split(',').forEach((itemCoverageUpdate) => {
      if (
        itemCoverageUpdate != '' &&
        this.coverages.some((obj) => obj.id === Number(itemCoverageUpdate))
      ) {
        var quotationCoverage: Coverage = {
          id: Number(itemCoverageUpdate),
          description: this.coverages.find((obj) => obj.id === Number(itemCoverageUpdate))!
            .description,
        };
        this.selectedCoverages.push(quotationCoverage);
        var coverageData: QuotationCompareCoverages = { coverageIds: Number(itemCoverageUpdate) };
        this.coveragesQuotationComparative.push(coverageData);
      }
    });
  }

  loadAnnualInsurances(insurancePaymentId: number) {
    this.annualInsurances = [];
    this.annualInsuranceService
      .getAnnualInsurances(insurancePaymentId, this.quotationId)
      .subscribe((response) => {
        this.annualInsurances = response;
      });
  }

  //solo financing?
  async loadDeadLinesUpdateQuotation(
    planId: number,
    insuranceId: number,
    programId: number,
    deadLinesUpdate: string,
  ) {
    this.deadLineQuotationComparative = [];
    this.deadLines = await firstValueFrom(
      this.deadLineService.getDeadLines(planId, insuranceId, programId),
    );
    var deadLineFilter: DeadLine[] = [];
    var deadLinesUpdateNumber: number[] = [];

    deadLinesUpdate.split(',').forEach((itemDeadLineUpdate) => {
      deadLinesUpdateNumber.push(Number(itemDeadLineUpdate));
    });

    deadLinesUpdateNumber.forEach((n) => {
      this.deadLines.forEach((deadLineFull) => {
        if (deadLineFull.id === n) {
          deadLineFilter.push(deadLineFull);
        }
      });
    });

    deadLineFilter.forEach((itemDeadLineUpdate) => {
      var quotationDeadLine: DeadLine = {
        id: itemDeadLineUpdate.id,
        description: itemDeadLineUpdate.description,
      };
      this.selectedDeadLines.push(quotationDeadLine);
    });

    deadLinesUpdate.split(',').forEach((itemDeadLineUpdate) => {
      var quotationDeadLineData: QuotationCompareDeadLines = {
        deadLineIds: Number(itemDeadLineUpdate),
      };
      this.deadLineQuotationComparative.push(quotationDeadLineData);
    });
  }

  loadDeadLineCompare() {
    this.deadLinesCompare = [];
    this.selectedDeadLines.forEach((deadLine) => {
      var quotationDeadLine: QuotationCompareDeadLines = { deadLineIds: deadLine.id };
      this.deadLinesCompare.push(quotationDeadLine);
    });
    return this.deadLinesCompare;
  }

  loadCoveragesCompare() {
    this.coveragesCompare = [];
    this.selectedCoverages.forEach((coverage) => {
      var quoationCoverage: QuotationCompareCoverages = { coverageIds: coverage.id };
      this.coveragesCompare.push(quoationCoverage);
    });

    return this.coveragesCompare;
  }

  loadVehicleUses() {
    this.vehicleUses = [];
    this.vehicleUseService.getVehicles(this.selectedBrand.id, 1).subscribe((response) => {
      this.vehicleUses = response;
    });
  }

  async loadPlans(brandId: number, modelId: number) {
    this.plans = await firstValueFrom(
      this.planService.getPlans(modelId, brandId, this.selectedPlanType.id),
    );
  }

  async loadInsurancePayments() {
    this.insurancePayments = await firstValueFrom(
      this.insurancePaymentService.getInsurancePayments(),
    );
  }

  isDeadLineSelected(deadLineId: number) {
    if (this.selectedDeadLines && this.selectedDeadLines.find((x) => x.id === deadLineId)) {
      this.checkDeadlines = this.selectedDeadLines.length;
      return this.selectedDeadLines.find((x) => x.id === deadLineId) != undefined;
    } else {
      return this.selectedDeadLines.find((x) => x.id === deadLineId) != undefined;
    }
  }

  isCoverageSelected(coverageId: number) {
    if (this.selectedCoverages && this.selectedCoverages.find((x) => x.id === coverageId)) {
      this.checkCoverages = this.selectedCoverages.length;
      return this.selectedCoverages.find((x) => x.id === coverageId) != undefined;
    } else {
      return this.selectedCoverages.find((x) => x.id === coverageId) != undefined;
    }
  }

  async updateQuotationComparative(deadLines: any, coverages: any) {
    this.quotationComparatives = await firstValueFrom(
      this.quotationService.compareQuotation(this.quotationId, deadLines, coverages),
    );
    this.selectedQuotationComparative = this.quotationComparatives!.find(
      (x) => x.deadlineId == this.selectedDeadline.id,
    )!;
    this.sendToComparative();
  }

  resetSelected() {
    const preCoverages: Coverage[] = this.selectedCoverages.filter((x) =>
      this.coverages.some((y) => y.description === x.description),
    );
    this.selectedDeadLines = this.selectedDeadLines.filter((x) =>
      this.deadLines.some((y) => y.id === x.id),
    );
    this.selectedCoverages = [];
    if (preCoverages.length > 0) {
      for (let i = 0; i < preCoverages.length; i++) {
        this.selectedCoverages.push(
          this.coverages.find((x) => x.description === preCoverages[i].description)!,
        );
      }
    }
    this.checkCoverages = this.selectedCoverages.length;
    this.checkDeadlines = this.selectedDeadLines.length;
  }

  deleteSelected() {
    this.selectedInsurance = {} as Insurance;
    this.financingFormGroup.get('insuranceCarrier')!.setValue(null);
    this.selectedDeadLines = [];
    this.selectedCoverages = [];
    this.deadLines = [];
    (this, (this.coverages = []));
    this.checkCoverages = this.selectedCoverages.length;
    this.checkDeadlines = this.selectedDeadLines.length;
    this.sendToComparative();
  }

  sendFinancingToParent() {
    this.financingReturn.emit({
      //se usa en summary
      // selectedPlanType: this.selectedPlanType,
      // selectedInsurance: this.selectedInsurance,
      selectedProgram: this.selectedProgram,
      selectedCoverages: this.selectedCoverages,
      selectedDeadLines: this.selectedDeadLines,
      deadLines: this.deadLines,
      coverages: this.coverages,
    });
  }

  sendToComparative() {
    // reinicio del componente comparativo
    this.comparativeData = {
      selectedDeadline: this.selectedDeadline,
      selectedDeadLines: this.selectedDeadLines,
      selectedQuotationComparative: this.selectedQuotationComparative,
      selectedQuotationFinancialValue: this.selectedQuotationFinancialValue,
      quotationComparatives: this.quotationComparatives,
      selectedCoverages: this.selectedCoverages,
    };
    this.comparativeComponentReturn.emit(this.comparativeData);
    //activar toolbar y activeToolbar
  }

  createTicketObj() {
    this.sendTicketObj.quotationId = this.quotationId;
    this.sendTicketObj.externalEmail = '';
    return this.sendTicketObj;
  }

  updateTicketObj() {
    this.updateItemTicketObj.quotationId = this.quotationId;
    this.updateItemTicketObj.ticketId = this.ticketId;
    return this.updateItemTicketObj;
  }

  createTicket() {
    this.loader.isLoadingPage(true);
    this.quotationService.sendTicket(this.createTicketObj()).subscribe((response) => {
      this.ticketId = response;
      this.loader.isLoadingPage(false);
      localStorage.setItem('ticketId', this.ticketId.toString());
    });
  }

  updateTicket() {
    this.loader.isLoadingPage(true);
    this.quotationService.updateTicket(this.updateTicketObj()).subscribe((response) => {
      this.loader.isLoadingPage(false);
      localStorage.setItem('ticketId', this.ticketId.toString());
    });
  }
}
